<template>
  <div id="app">
    <div class="header">
      <menu-bar>
        <router-link to="/" slot="title">
          <h1>Bendpanic</h1>
          <h2 class="subheader">Production</h2>
        </router-link>

        <categories :categories="categories" slot="categories"></categories>
      </menu-bar>
    </div>

    <router-view></router-view>

    <foot></foot>
  </div>
</template>

<script>
import MenuBar from './components/MenuBar';
import Categories from './components/Categories';
import Foot from './components/Foot';

export default {
  name: 'app',
  components: {
    MenuBar,
    Categories,
    Foot
  },
  computed: {
    projects () {
      return this.$store.getters.projects;
    },
    categories () {
      return this.$store.getters.categories;
    },
    selectedProject () {
      return this.$store.getters.selectedProject;
    }
  },
  methods: {
    clearFilters () {
      this.setProject(null);
      this.setCategory(null);
    },
    setProject (project) {
      this.$store.dispatch('setProject', project);
    },
    setCategory (category) {
      this.$store.dispatch('setCategory', category);
    }
  }
}
</script>

<style lang="scss">
#app {
  display: flex;
  flex-direction: column;

  /* min-width: 412px; */
  max-width: 910px;
  min-height: 100%;

  margin-right: auto;
  margin-left: auto;
  justify-content: space-between;

  // padding: 0px 0.8rem;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 2rem 0 1rem 0;

  @media only screen and (max-width: 512px) {
    padding: 2rem 0 0 0;
  }
}

.subheader {
  text-align: end;
}

.page {
  margin-bottom: auto;

  & > h2 {
    padding: 1rem 0 2rem 0;
    line-height: 1.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?2142e4d1